import React from 'react'
import './filter.scss'
import Dropdown from '../../common/dropdown-v2/dropdown'

import SchoolApi from '../../../apis/school'
import MasterDataApi from '../../../apis/master-data'
import 'bootstrap-daterangepicker/daterangepicker.css'
import 'bootstrap/dist/css/bootstrap.css'
class FilterComponent extends React.Component {
  state = {
    showFilters: true,

    classDropDownItems: [],

    boardDropDownItems: [],

    sectionDropdownItems: [],

    statusDropdownItems: [
      {
        title: 'Invite Sent',
        value: 'INVITE_SENT'
      },
      { title: 'Accepted', value: 'ACCEPTED' }
    ]
  }

  componentDidMount () {
    this.getClassAndBoard()
  }

  reloadDropdown () {
    this.setState({ reloadDropdown: true }, () => {
      this.setState({ reloadDropdown: false })
    })
  }

  refreshPage () {
    this.setState({ reload: true }, () => this.setState({ reload: false }))
  }

  toggleFilters = () => {
    this.setState({ showFilters: !this.state.showFilters })
  }

  onSelectDropDown = (option, key) => {
    const { screen } = this.props
    this.refreshPage()
    this.setState({ [key]: option?.value, [`${key}Object`]: option }, _ => {
      if (key === 'selectedClass') this.getSectionsApi()
    })
  }

  onClickGo = () => {
    const { selectedClass, selectedBoard, selectedSection, selectedStatus } = this.state
    let payload = {}
    if (selectedBoard) {
      payload.board = selectedBoard
    }
    if (selectedClass) {
      payload.class = selectedClass
    }
    if (selectedSection) {
      payload.section = selectedSection
    }
    if (selectedStatus) {
      payload.status = selectedStatus
    }
    if (this.props.delegate.onFilterGo) {
      this.props.delegate.onFilterGo(payload)
    }
  }

  clearFilter = () => {
    this.setState(
      {
        selectedClass: '',
        selectedSection: '',
        selectedStatus: '',
        selectedBoard: ''
      },
      () => {
        this.refreshPage()
        if (this.props.delegate.onFilterGo) {
          this.props.delegate.onFilterGo()
        }
      }
    )
  }

  refreshPage () {
    this.setState({ reload: true }, () => this.setState({ reload: false }))
  }

  onChangeHandler (event, key) {
    let value = event.target.value
    this.setState({ [key]: value })
  }

  getClassAndBoard (payload = {}) {
    SchoolApi.getClassAndBoard(payload)
      .then(school => {
        const classes = [], boards = []
        for (let i = 0; i < school.classes.length; i++) {
          classes.push({
            title: school.classes[i].name,
            value: school.classes[i].name
          })
        }

        for (let i = 0; i < school.boards.length; i++) {
          boards.push({
            title: school.boards[i].name,
            value: school.boards[i].name
          })
        }
        let board = ""
        if(boards.length === 1) board = boards[0].title

        this.setState({ classDropDownItems: classes, boardDropDownItems: boards, selectedBoard: board })
      })
      .catch(err => {
        this.setState({ classDropDownItems: [], boardDropDownItems: [] })
      })
  }

  getSectionsApi () {
    let payload = {
      class: this.state.selectedClass
    }

    SchoolApi.getSections(payload)
      .then(response => {
        const sections = []
        for (let i = 0; i < response.response.length; i++) {

          if(!response.response[i].noSectionInClass) {
            sections.push({
              title: response.response[i].section,
              value: response.response[i].section
            })
          }

          
        }
        console.log(sections, response)
        this.setState({ sectionDropdownItems: sections })
      })
      .catch(err => {
        this.setState({ sectionDropdownItems: [] })
      })
  }

  render () {
    const {
      selectedBoard,
      selectedClass,
      selectedSection,
      selectedStatus,
      reload,
      reloadDropdown,
      classDropDownItems,
      boardDropDownItems,
      sectionDropdownItems,
      statusDropdownItems,
      showFilters
    } = this.state
    return (
      <div className='student-filter'>
        <div className='filter-header'>
          <div className='d-inline' onClick={this.toggleFilters}>
            <div className='filter-title d-inline'>{'Filters'}</div>
            <div className='d-inline'>
              <i
                class={showFilters ? 'filter-arrow up' : 'filter-arrow down'}
              ></i>
            </div>
          </div>
        </div>
        {!reload ? (
          <div
            className={showFilters ? 'filter-content' : 'filter-content d-none'}
          >
            <div className='row'>
              {boardDropDownItems.length > 1 && 
                <div className='col-lg-3 col-md-6 col-sm-12 pt-4'>
                  <div className='filter-input-label'>Board</div>
                  <div>
                    {!reloadDropdown ? (
                      <Dropdown
                        key='class'
                        placeholder='Select Board'
                        options={boardDropDownItems}
                        onSelect={option =>
                          this.onSelectDropDown(option, 'selectedBoard')
                        }
                        text={'title'}
                        value={selectedBoard}
                      ></Dropdown>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              }
              <div className='col-lg-3 col-md-6 col-sm-12 pt-4'>
                <div className='filter-input-label'>Class</div>
                <div>
                  {!reloadDropdown ? (
                    <Dropdown
                      key='class'
                      placeholder='Select Class'
                      options={classDropDownItems}
                      onSelect={option =>
                        this.onSelectDropDown(option, 'selectedClass')
                      }
                      text={'title'}
                      value={selectedClass}
                    ></Dropdown>
                  ) : (
                    ''
                  )}
                </div>
              </div>
              <div className='col-lg-3 col-md-6 col-sm-12 pt-4'>
                <div className='filter-input-label'>Section</div>
                <div>
                  {!reloadDropdown ? (
                    <Dropdown
                      key='section'
                      placeholder='Select Section'
                      options={sectionDropdownItems}
                      onSelect={option =>
                        this.onSelectDropDown(option, 'selectedSection')
                      }
                      text={'title'}
                      value={selectedSection}
                    ></Dropdown>
                  ) : (
                    ''
                  )}
                </div>
              </div>
              <div className='col-lg-3 col-md-6 col-sm-12 pt-4'>
                <div className='filter-input-label'>Status</div>
                <div>
                  {!reloadDropdown ? (
                    <Dropdown
                      key='status'
                      placeholder='Select Status'
                      options={statusDropdownItems}
                      onSelect={option =>
                        this.onSelectDropDown(option, 'selectedStatus')
                      }
                      text={'title'}
                      value={selectedStatus}
                    ></Dropdown>
                  ) : (
                    ''
                  )}
                </div>
              </div>
              <div className='col ml-2 my-auto pt-4 text-right'>
                <div className='filter-button  d-inline-block'>
                  <button
                    className={`cw-button`}
                    onClick={this.onClickGo.bind(this)}
                  >
                    {'GO'}
                  </button>
                </div>
                <div className='filter-button ml-3 d-inline-block'>
                  <button
                    className={`cw-button clear-btn`}
                    onClick={this.clearFilter.bind(this)}
                  >
                    {'CLEAR'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    )
  }
}

export default FilterComponent
